"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallationOrderPayloadResponse = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class InstallationOrderPayloadResponse extends base_models_1.Serializable {
}
exports.InstallationOrderPayloadResponse = InstallationOrderPayloadResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: [
            {
                date: '2011-10-05T14:48:00.000Z',
                payloadUrl: '/api/internal/essent/emobility/document/v1?document_id=email2.eml',
            },
        ],
        description: 'case data in BPM',
    }),
    (0, class_validator_1.IsArray)(),
    tslib_1.__metadata("design:type", Array)
], InstallationOrderPayloadResponse.prototype, "payloads", void 0);
